module.exports = __webpack_public_path__ + "img/logo.1f88f46b.svg";